export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=709e5181d7af2c4ca4e47bcf2acccc0c8a20b7cc0a&name=pushAdClickData!'